module.exports = __webpack_public_path__ + "static/media/300_Racoons.0530b870.webp";